import { HomePage } from "../pages/HomePage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { PrivacyPage } from "../pages/PrivacyPage";

function normalizePathname(pathname: string) {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }

  return pathname;
}

export function App() {
  const pathname = normalizePathname(window.location.pathname);
  const page =
    pathname === "/" ? (
      <HomePage />
    ) : pathname === "/privacy" ? (
      <PrivacyPage />
    ) : (
      <NotFoundPage />
    );

  return (
    <>
      <a className="skip-link" href="#main-content">
        本文へ移動する
      </a>
      {page}
    </>
  );
}
